import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import defaultUser from '../assets/img/default-user.svg';
import { getCurrentUser } from '../utils/services/authService';
import '../assets/css/header.css';

const Header = ({ history, display }) => {
  const [photo, setPhoto] = useState(null);

  const loadUserPhoto = async () => {
    const token = localStorage.getItem('authToken');
    if (!token) return;

    try {
      const { data } = await getCurrentUser(token);

      const userPhoto = data?.user?.photo || null;

      userPhoto && setPhoto(userPhoto);
    } catch (err) {
      console.error('Error cargando usuario:', err);
    }
  };

  const handleGoBack = () => {
    history.goBack();
  };

  useEffect(() => {
    loadUserPhoto();
  }, []);

  return (
    <header className="header">
      <a onClick={handleGoBack} className={`btn-back ${display}`} />
      <div className="logoblue" />
      <a href="/profile" className="userimage">
        <img src={photo || defaultUser} alt="Photo user profile" />
      </a>
    </header>
  );
};

Header.propTypes = {
  history: PropTypes.object,
  display: PropTypes.string,
};

export default withRouter(Header);
